import langAPI from '../../_api/lang';

export const getLangList = () => async (dispatch) => {
  const response = await langAPI.getAvailableList();
  if (response){
    return response.map(l => ({ value: l.id, label: l.name }))
  };
};
